import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhexiantu",
  "use": "icon-zhexiantu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhexiantu\">\r\n  <path d=\"M845.815 750.614h0.059v-0.364l-0.059 0.364z m0 0M128.025 831.721h832.33v63.919h-832.33zM127.305 125.784h64.733v705.937h-64.733zM141.815 517.275l197.052-197.052 45.076 45.076L186.89 562.351zM430.124 320.161L656.44 546.477l-45.109 45.109L385.015 365.27zM640.02 530.97l275.469-275.468 45.076 45.077-275.469 275.468zM319.041 255.953h129.046v128.429H319.041zM576.112 513.223h128.025v126.742H576.112z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhexiantu.svg
// module id = tgG+
// module chunks = 54